export default __webpack_public_path__ + "static/media/meta_desc.a39e578e.svg";